module.exports = __webpack_public_path__ + "static/media/ic_trash.e66bd9d7.svg";